import { render } from "./AnswerForSingleQuestion.vue?vue&type=template&id=1a5836bf&scoped=true&ts=true"
import script from "./AnswerForSingleQuestion.vue?vue&type=script&lang=ts"
export * from "./AnswerForSingleQuestion.vue?vue&type=script&lang=ts"

import "./AnswerForSingleQuestion.vue?vue&type=style&index=0&id=1a5836bf&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5836bf"]])

export default __exports__